import yup, { integerPositiveValidator } from '~/utils/validators.yup';

export const rewardPenaltyDetailRule = {
    rewardPenaltyDetail: yup.object().shape({
        lampRewardValue: integerPositiveValidator,
        pointRewardValue: integerPositiveValidator,
        upgradeRewardValue: integerPositiveValidator,
        manaRewardValue: integerPositiveValidator,
        lampRemovedValue: integerPositiveValidator,
        point1RemovedValue: integerPositiveValidator,
        point2RemovedValue: integerPositiveValidator,
        upgradeRemovedValue: integerPositiveValidator,
        manaRemovedValue: integerPositiveValidator,
    }),
};
